"use client";

import { CheckCircle } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { services } from "@/content/services";

export function ServicesSection() {
  const sectionRef = useRevealOnScroll<HTMLElement>({
    threshold: 0.1,
    staggerInterval: 100,
  });

  return (
    <section ref={sectionRef} id="services" className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        {/* Section Header */}
        <div className="reveal mb-20 text-center">
          <div className="text-luxury-green mb-6 inline-flex items-center space-x-3">
            <div className="bg-luxury-green h-0.5 w-12" />
            <span className="text-sm font-semibold tracking-[0.3em] uppercase">
              Наши услуги
            </span>
            <div className="bg-luxury-green h-0.5 w-12" />
          </div>
          <h2 className="font-display text-luxury-dark mb-6 text-5xl font-bold lg:text-7xl">
            Что мы делаем
          </h2>
          <p className="text-luxury-stone mx-auto max-w-3xl text-xl">
            Специализируемся на двух ключевых направлениях с использованием
            профессионального оборудования и качественных материалов.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid gap-8 lg:grid-cols-2">
          {services.map((service) => (
            <div
              key={service.id}
              className="group bg-luxury-cream hover-lift reveal relative p-10 lg:p-14"
            >
              <div className="gradient-luxury absolute top-0 left-0 h-1 w-full scale-x-0 transform transition-transform duration-500 group-hover:scale-x-100" />
              <div className="mb-8 flex items-start justify-between">
                <span className="font-display text-luxury-green/30 text-6xl">
                  {service.number}
                </span>
                <service.icon className="text-luxury-green h-8 w-8" />
              </div>
              <h3 className="font-display text-luxury-dark mb-6 text-3xl font-bold lg:text-4xl">
                {service.title}
              </h3>
              <p className="text-luxury-stone mb-8 leading-relaxed">
                {service.description}
              </p>
              <ul className="space-y-4">
                {service.features.map((feature) => (
                  <li key={feature} className="flex items-center space-x-3">
                    <CheckCircle className="text-luxury-green h-5 w-5 flex-shrink-0" />
                    <span className="text-luxury-stone">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
